import { useMemo } from 'react';
import { skipToken, useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getInvestorHoldingTransactions } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import type { HoldingTransactionsResult } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingTransactionsModal/useHoldingTransactions.types.ts';
import { InvestorHoldingRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/investorHoldings.types.ts';

export const useHoldingTransactions = ({
	investorId,
	holding,
}: {
	investorId: string;
	holding: InvestorHoldingRow | null;
}): HoldingTransactionsResult => {
	const scope = holding && {
		investorId,
		holderId: holding.holderId,
		securityId: holding.securityId,
		programmeId: holding.investmentProgrammeId ?? undefined,
	};

	const query = useQuery({
		queryKey: [API_PATHS.MIP_INVESTOR_HOLDINGS_ID_TRANSACTIONS_GET, scope],
		queryFn: scope
			? ({ signal }) =>
					getInvestorHoldingTransactions(
						API_PATHS.MIP_INVESTOR_HOLDINGS_ID_TRANSACTIONS_GET,
						scope,
						signal
					)
			: skipToken,
		select: (response) => response.payload,
	});
	const rows = useMemo(() => query.data ?? [], [query.data]);

	return { rows, isLoading: query.isPending && !!scope, isError: query.isError };
};
